import { Checkbox, Divider, FormControlLabel, Typography } from "@mui/material"
import InputBlock from "components/controls/input-block"
import { observer } from "mobx-react-lite"
import Block from "../../store/block"
import { BlockInfoContainer } from "./styled"

type Props = {
  title?: string,
  state: Block
  children: React.ReactNode
}

const BlockInfo = observer(({ children, title, state }: Props) => {

  return (
    <BlockInfoContainer className="block-info" onMouseDown={e => e.stopPropagation()}>
      <svg width="18" height="9" viewBox="0 0 18 9">
        <path d="M9 0L18 9H0L9 0Z" fill="currentColor"/>
      </svg>
      <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
        { title || "Настройки" }
      </Typography>
      { children }
      { children && <Divider sx={{ fontSize: 9, color: "text.disabled" }}>Прочее</Divider> }
      <FormControlLabel control={<Checkbox {...state.checkboxProps('required', true)} />} label="Обязательный блок" />
      <InputBlock {...state.dataProps('description')} placeholder="Описание" multiline={true}/>
    </BlockInfoContainer>
  )
})

export default BlockInfo